var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1950_5309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 17.5001C10.6223 17.5001 11.6518 17.2953 12.6123 16.8975C13.5728 16.4996 14.4455 15.9165 15.1806 15.1813C15.9157 14.4462 16.4989 13.5735 16.8967 12.613C17.2946 11.6525 17.4993 10.623 17.4993 9.58342C17.4993 8.54378 17.2946 7.51433 16.8967 6.55384C16.4989 5.59334 15.9157 4.72062 15.1806 3.98549C14.4455 3.25036 13.5728 2.66722 12.6123 2.26937C11.6518 1.87152 10.6223 1.66675 9.58268 1.66675C7.48305 1.66675 5.46942 2.50082 3.98475 3.98549C2.50009 5.47015 1.66602 7.48378 1.66602 9.58342C1.66602 11.683 2.50009 13.6967 3.98475 15.1813C5.46942 16.666 7.48305 17.5001 9.58268 17.5001Z",
    stroke: "#16262E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 18.3334L16.666 16.6667",
    stroke: "#16262E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1950_5309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a8fa071d960b9db86ba8440c2198792a.svg";
export { ForwardRef as ReactComponent };